/**
 * The XSS link rule (spec §6): a link renders only for `https:`, `mailto:` or
 * a same-origin URL. Anything else (javascript:, data:, http: to elsewhere,
 * protocol-relative `//host`, backslash tricks) renders as plain text.
 */
export function isSafeHref(href: string | null | undefined, origin: string = currentOrigin()): boolean {
  if (!href) return false;
  const raw = href.trim();
  if (raw === '' || /[\u0000-\u001f\\]/.test(raw)) return false;
  // Same-origin path: '/x' but never '//host' (protocol-relative).
  if (raw.startsWith('/')) return !raw.startsWith('//');
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return false;
  }
  if (url.protocol === 'https:' || url.protocol === 'mailto:') return true;
  return origin !== '' && url.origin === origin;
}

function currentOrigin(): string {
  return typeof window === 'undefined' ? '' : window.location.origin;
}
